import styled from 'styled-components/macro'
import MainMenuEntry from "./MainMenuEntry";

const Menu = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding-top: ${p => p.theme.spacing};
`;

export default ({ menu }) => (
  <Menu>
    { menu.map(entry => <MainMenuEntry key={ entry.title } { ...entry } />) }
  </Menu>
);
